import * as React from "react";

import LoginContainer from "../../components/LoginContainer/LoginContainer";
import LoginCard from "../../components/LoginCard/LoginCard";
import { useAuth } from "../../hooks/useAuth";

const Login = () => {
  const { sessionExpired } = useAuth();

  return (
    <LoginContainer>
      <LoginCard sessionExpired={sessionExpired} />
    </LoginContainer>
  );
};

export default Login;
